<template>
	<div
		:data-transparent-header="blok.transparent_header ? '' : null"
		:class="`${blok.background_color || ''} ${blok.text_color} ${blok.full_width ? 'full-bleed' : ''} ${blok.margin || ''} ${blok.padding || ''}`"
	>
		<div
			class="main-wrapper"
			:class="`${blok.is_content_offset ? '' : '!px-0'} ${blok.gap ? `grid grid-cols-1 ${blok.gap}` : ''}`"
		>
			<p
				v-if="blok.title"
				:class="`${arrayToString(blok.title_styles) || 'lg:mb-15 mb-7 text-center text-[55px] font-heldane'}`"
			>
				{{ blok.title }}
			</p>
			<StoryblokComponent
				v-for="block in blok.blocks"
				:key="block._uid"
				:blok="block"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { Container } from "~/types/storyblok/storyblok";
import { arrayToString } from "~/utils/arrayToString";

interface Props {
	blok: Container;
}

const { blok } = defineProps<Props>();
</script>
